import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IsDesktopService {
  desktop = false;
  largeDesktop = false;
  desktopBreakpointSubscription!: Subscription;
  largeDesktopBreakpointSubscription!: Subscription;

  private _isDesktop: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isDesktop: Observable<boolean> = this._isDesktop.asObservable();

  private _isLargeDesktop: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isLargeDesktop: Observable<boolean> = this._isLargeDesktop.asObservable();

  constructor(private observer: BreakpointObserver) {
    this.desktopBreakpointSubscription = this.observer.observe(environment.breakpoints.above.lg).subscribe((result) => {
      if (environment.breakpoints.above.lg in result.breakpoints) {
        if (result.breakpoints[environment.breakpoints.above.lg] !== this.desktop) {
          this.desktop = result.breakpoints[environment.breakpoints.above.lg];
          this._isDesktop.next(this.desktop);
        }
      }
    });
    this.largeDesktopBreakpointSubscription = this.observer
      .observe(environment.breakpoints.above.xxxl)
      .subscribe((result) => {
        if (environment.breakpoints.above.xxxl in result.breakpoints) {
          if (result.breakpoints[environment.breakpoints.above.xxxl] !== this.largeDesktop) {
            this.largeDesktop = result.breakpoints[environment.breakpoints.above.xxxl];
            this._isLargeDesktop.next(this.largeDesktop);
          }
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.desktopBreakpointSubscription) {
      this.desktopBreakpointSubscription.unsubscribe();
    }
    if (this.largeDesktopBreakpointSubscription) {
      this.largeDesktopBreakpointSubscription.unsubscribe();
    }
  }
}
